import React from 'react';
import CardContainer from './CardContainer';

export default function RevenueEngineSection({styles, revenueStat, roiStat}) {
  return (
    <section
          className={`${styles.container} ${styles.revenueEngineSection}`}
        >
          <div className={styles.headingContainer}>
            <h1 className={styles.sectionTitle}>
              Your AI Revenue Engine That Never Sleeps
            </h1>
            <p className={styles.sectionSubTitle}>
              While you focus on growing your business, Instant AI works 24/7 to
              maximize every customer touchpoint and squeeze more profit from
              your existing traffic.
            </p>
          </div>
          <ul className={styles.cardContainer}>
            <li className="half-width">
              <CardContainer className={styles.aiCard}>
                <h2 className={`${styles.cardHeading} green-text`}>
                  Recover Lost Sales
                </h2>
                <p className={styles.cardStats}>30-50%</p>
                <p className={styles.cardDesc}>
                  Convert abandoned carts into sales with timely recovery
                  messages that feel personal.
                </p>
              </CardContainer>
            </li>

            <li className="half-width">
              <CardContainer className={styles.aiCard}>
                <h2 className={`${styles.cardHeading} green-text`}>
                  Boost Flow Performance
                </h2>
                <p className={styles.cardStats}>{revenueStat}</p>
                <p className={styles.cardDesc}>
                  Boost flow performance with smart upsells,
                  cross-sells, and retention strategies.
                </p>
              </CardContainer>
            </li>

            <li className="half-width">
              <CardContainer className={styles.aiCard}>
                <h2 className={`${styles.cardHeading} green-text`}>
                  Maximize Marketing ROI
                </h2>
                <p className={styles.cardStats}>{roiStat}</p>
                <p className={styles.cardDesc}>
                  Maximize your budget with AI personalization that converts visitors into loyal customers.
                </p>
              </CardContainer>
            </li>
          </ul>
        </section>
  );
}